<div class="icon-wrapper">
  <img class="warning-strong-icon confirm-content-icon" src="/assets/img/channels/warning-strong.svg"
       alt="warning-strong">
</div>

<h3 mat-dialog-title class="modal-header" translate>PLANS.CHANGE_PLAN_CONFIRM_DIALOG.DOWNGRADE_TITLE</h3>

<mat-dialog-content class="mat-typography plan-features-modal-content">
  <div class="plan-features">
    <h4 *ngIf="overLimits.length" class="plan-features-subheader" translate>
      PLANS.CHANGE_PLAN_CONFIRM_DIALOG.BEFORE_DOWNGRADE</h4>
    <ul class="plan-features-list">
      <li class="plan-features-list-item" *ngFor="let overLimit of overLimits">
        <ng-container *ngIf="autoIntegrationRemoval(overLimit); else defaultOverLimit">
          <span>{{ ('PLANS.CHANGE_PLAN_CONFIRM_DIALOG.INTEGRATIONS_AUTO_REMOVAL') | translate:{
            from: overLimit.current,
            to: overLimit.limit
          } }}</span>
        </ng-container>
        <ng-template #defaultOverLimit>
        <span>{{ ('PLANS.CHANGE_PLAN_CONFIRM_DIALOG.' + overLimit.feature) | translate:{
          from: overLimit.current,
          to: overLimit.limit
        } }}</span>
        <a [routerLink]="overLimit.link" class="plan-features-link" (click)="closeDialog()">here</a>
        </ng-template>
      </li>
    </ul>

    <ng-container *ngIf="differences.length">
      <h4 *ngIf="!overLimits.length" class="plan-features-subheader" translate>
        PLANS.CHANGE_PLAN_CONFIRM_DIALOG.MISSING_FEATURES</h4>
      <h4 *ngIf="overLimits.length" class="plan-features-subheader" translate>
        PLANS.CHANGE_PLAN_CONFIRM_DIALOG.MISSING_FEATURES_ADDITIONALLY</h4>
      <ul class="plan-features-list">
        <li class="plan-features-list-item" *ngFor="let diff of differences">
        <span *ngIf="diff.value.from">{{ ('PLANS.CHANGE_PLAN_CONFIRM_DIALOG.' + diff.key) | translate:{
          from: diff.value.from,
          to: diff.value.to
        } }}</span>
          <span
            *ngIf="!diff.value.from">{{ ('PLANS.CHANGE_PLAN_CONFIRM_DIALOG.' + diff.key) | translate:{ value: diff.value } }}</span>
        </li>
      </ul>
    </ng-container>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="canProceed()">
  <button class="plan-features-buttons" mat-raised-button color="info-full" [mat-dialog-close]="false">
    {{ 'CLOSE' | translate }}
  </button>
  <button class="plan-features-buttons"
          mat-raised-button
          color="primary-full"
          [mat-dialog-close]="true">
    {{ 'PROCEED' | translate }}
  </button>
</mat-dialog-actions>
<mat-dialog-actions align="center" *ngIf="!canProceed()">
  <button mat-raised-button color="info-full" [mat-dialog-close]="false">
    {{ 'CLOSE' | translate }}
  </button>
</mat-dialog-actions>
